import React from 'react';
import website from '@/assets/Video/website.mp4'


export default function Videos(link) {
    return (
        <div className="flex mx-auto px-10 my-10 lg:my-20 md:grid-cols-3 gap-10 sm: grid grid-cols-1">
            <iframe
                class="w-full aspect-video rounded-xl border-2 border-gray-200"
                src={link[0]}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
            <iframe
                class="w-full aspect-video rounded-xl border-2 border-gray-200"
                src={link[1]}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
            <iframe
                class="w-full aspect-video rounded-xl border-2 border-gray-200"
                src={link[2]}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
        </div>
    );
}

export const VideoArray = [
    [
        'https://www.youtube.com/embed/XOukH-ec_HA?controls=1',
        'https://www.youtube.com/embed/xLUWIZgyAm8?controls=1',
        'https://www.youtube.com/embed/MC4_JSnAOs8?controls=1&modestbranding=1"',
    ],
    [
        'https://www.youtube.com/embed/Qq08VyddQrQ?controls=1',
        'https://www.youtube.com/embed/rfx7Uqoc1vA?controls=1',
        'https://www.youtube.com/embed/DEU_pRFQKDc?controls=1'
    ],
    [
        'https://www.youtube.com/embed/9bLWN2Sz_z4?controls=1',
        'https://www.youtube.com/embed/ZStPVGmAh0I?controls=1',
        'https://www.youtube.com/embed/_-GERAO2KXY?controls=1'
    ],
];
export const VideosArray = VideoArray.map((video) => {
    return Videos(video);
});
